import React, { useState, useEffect } from 'react';

// Animated Dino sprite - AQUAMARINE with WHITE eye
// Values: 0=empty, 1=dino color, 2=white (eye)
const DinoSprite = ({ frame }) => {
  const pixels1 = [
    [0,0,0,0,0,0,1,1,1,1,1,1],
    [0,0,0,0,0,1,1,1,1,1,1,1,1],
    [0,0,0,0,0,1,1,2,1,1,1,1,1],
    [0,0,0,0,0,1,1,1,1,1,1,1],
    [0,0,0,0,0,1,1,1,1,0,0,0],
    [0,0,0,1,0,1,1,1,1,1,0,0],
    [0,0,1,1,1,1,1,1,1,1,0,0],
    [0,1,1,1,1,1,1,1,1,0,0,0],
    [1,1,1,1,1,1,1,1,0,0,0,0],
    [0,1,1,1,1,1,1,1,0,0,0,0],
    [0,0,1,1,1,1,1,0,0,0,0,0],
    [0,0,0,1,1,0,1,1,0,0,0,0],
    [0,0,0,1,0,0,0,1,0,0,0,0],
    [0,0,0,1,1,0,0,0,0,0,0,0],
  ];
  
  const pixels2 = [
    [0,0,0,0,0,0,1,1,1,1,1,1],
    [0,0,0,0,0,1,1,1,1,1,1,1,1],
    [0,0,0,0,0,1,1,2,1,1,1,1,1],
    [0,0,0,0,0,1,1,1,1,1,1,1],
    [0,0,0,0,0,1,1,1,1,0,0,0],
    [0,0,0,1,0,1,1,1,1,1,0,0],
    [0,0,1,1,1,1,1,1,1,1,0,0],
    [0,1,1,1,1,1,1,1,1,0,0,0],
    [1,1,1,1,1,1,1,1,0,0,0,0],
    [0,1,1,1,1,1,1,1,0,0,0,0],
    [0,0,1,1,1,1,1,0,0,0,0,0],
    [0,0,0,1,0,1,0,0,0,0,0,0],
    [0,0,0,1,0,1,0,0,0,0,0,0],
    [0,0,1,1,0,1,1,0,0,0,0,0],
  ];
  
  const pixels = frame === 0 ? pixels1 : pixels2;
  const colors = { 1: '#00E5CC', 2: '#FFFFFF' };
  
  return (
    <div 
      className="relative" 
      style={{ width: '48px', height: '56px' }}
    >
      {pixels.map((row, y) => 
        row.map((pixel, x) => 
          pixel > 0 && (
            <div
              key={`${x}-${y}`}
              className="absolute"
              style={{
                left: `${x * 4}px`,
                top: `${y * 4}px`,
                width: '4px',
                height: '4px',
                backgroundColor: colors[pixel],
              }}
            />
          )
        )
      )}
    </div>
  );
};

// Animated Llama sprite - DEEP PURPLE - Same as Timer page
const LlamaSprite = ({ frame }) => {
  // Llama with ears, neck, body, and legs - matching Timer design
  const pixels = [
    [0,0,0,1,0,1,0,0],
    [0,0,0,1,1,1,0,0],
    [0,0,0,0,1,0,0,0],
    [0,0,0,0,1,0,0,0],
    [0,0,0,0,1,0,0,0],
    [0,0,1,1,1,1,0,0],
    [0,1,1,1,1,1,1,0],
    [0,1,1,1,1,1,1,0],
    [0,0,1,1,1,1,0,0],
    [0,0,1,0,0,1,0,0],
    [0,0,1,0,0,1,0,0],
    [0,0,1,0,0,1,0,0],
  ];
  
  return (
    <div 
      className="relative" 
      style={{ width: '32px', height: '48px' }}
    >
      {pixels.map((row, y) => 
        row.map((pixel, x) => 
          pixel === 1 && (
            <div
              key={`${x}-${y}`}
              className="absolute"
              style={{
                left: `${x * 4}px`,
                top: `${y * 4}px`,
                width: '4px',
                height: '4px',
                backgroundColor: '#7C3AED',
              }}
            />
          )
        )
      )}
    </div>
  );
};

// Simple inline translation indicator for small size
const InlineTranslationLoader = ({ message }) => {
  return (
    <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary/10 rounded-full border border-primary/20">
      {/* Mini dino icon */}
      <svg width="16" height="16" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="6" y="0" width="1" height="1" fill="#00E5CC"/>
        <rect x="7" y="0" width="1" height="1" fill="#00E5CC"/>
        <rect x="8" y="0" width="1" height="1" fill="#00E5CC"/>
        <rect x="9" y="0" width="1" height="1" fill="#00E5CC"/>
        <rect x="10" y="0" width="1" height="1" fill="#00E5CC"/>
        <rect x="11" y="0" width="1" height="1" fill="#00E5CC"/>
        <rect x="5" y="1" width="1" height="1" fill="#00E5CC"/>
        <rect x="6" y="1" width="1" height="1" fill="#00E5CC"/>
        <rect x="7" y="1" width="1" height="1" fill="#FFFFFF"/>
        <rect x="8" y="1" width="1" height="1" fill="#00E5CC"/>
        <rect x="9" y="1" width="1" height="1" fill="#00E5CC"/>
        <rect x="10" y="1" width="1" height="1" fill="#00E5CC"/>
        <rect x="11" y="1" width="1" height="1" fill="#00E5CC"/>
        <rect x="5" y="2" width="1" height="1" fill="#00E5CC"/>
        <rect x="6" y="2" width="1" height="1" fill="#00E5CC"/>
        <rect x="7" y="2" width="1" height="1" fill="#00E5CC"/>
        <rect x="8" y="2" width="1" height="1" fill="#00E5CC"/>
        <rect x="9" y="2" width="1" height="1" fill="#00E5CC"/>
        <rect x="3" y="3" width="1" height="1" fill="#00E5CC"/>
        <rect x="5" y="3" width="1" height="1" fill="#00E5CC"/>
        <rect x="6" y="3" width="1" height="1" fill="#00E5CC"/>
        <rect x="7" y="3" width="1" height="1" fill="#00E5CC"/>
        <rect x="8" y="3" width="1" height="1" fill="#00E5CC"/>
        <rect x="2" y="4" width="1" height="1" fill="#00E5CC"/>
        <rect x="3" y="4" width="1" height="1" fill="#00E5CC"/>
        <rect x="4" y="4" width="1" height="1" fill="#00E5CC"/>
        <rect x="5" y="4" width="1" height="1" fill="#00E5CC"/>
        <rect x="6" y="4" width="1" height="1" fill="#00E5CC"/>
        <rect x="7" y="4" width="1" height="1" fill="#00E5CC"/>
        <rect x="0" y="5" width="1" height="1" fill="#00E5CC"/>
        <rect x="1" y="5" width="1" height="1" fill="#00E5CC"/>
        <rect x="2" y="5" width="1" height="1" fill="#00E5CC"/>
        <rect x="3" y="5" width="1" height="1" fill="#00E5CC"/>
        <rect x="4" y="5" width="1" height="1" fill="#00E5CC"/>
        <rect x="5" y="5" width="1" height="1" fill="#00E5CC"/>
        <rect x="6" y="5" width="1" height="1" fill="#00E5CC"/>
        <rect x="1" y="6" width="1" height="1" fill="#00E5CC"/>
        <rect x="2" y="6" width="1" height="1" fill="#00E5CC"/>
        <rect x="3" y="6" width="1" height="1" fill="#00E5CC"/>
        <rect x="4" y="6" width="1" height="1" fill="#00E5CC"/>
        <rect x="5" y="6" width="1" height="1" fill="#00E5CC"/>
        <rect x="6" y="6" width="1" height="1" fill="#00E5CC"/>
        <rect x="3" y="7" width="1" height="1" fill="#00E5CC"/>
        <rect x="5" y="7" width="1" height="1" fill="#00E5CC"/>
        <rect x="6" y="7" width="1" height="1" fill="#00E5CC"/>
      </svg>
      <span className="text-xs font-medium text-primary animate-pulse">{message}</span>
      <span className="flex gap-0.5">
        <span className="w-1 h-1 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></span>
        <span className="w-1 h-1 bg-primary rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></span>
        <span className="w-1 h-1 bg-primary rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></span>
      </span>
    </div>
  );
};

// Main DinoLlamaLoader component
export const DinoLlamaLoader = ({ message = "Translating...", size = "md" }) => {
  const [frame, setFrame] = useState(0);
  
  // Animate the sprites
  useEffect(() => {
    const interval = setInterval(() => {
      setFrame(f => (f + 1) % 2);
    }, 200);
    return () => clearInterval(interval);
  }, []);
  
  const sizeClasses = {
    sm: 'scale-50',
    md: 'scale-75',
    lg: 'scale-100'
  };
  
  return (
    <div className={`flex flex-col items-center justify-center gap-4 py-4 ${size === 'sm' ? 'py-2' : ''}`}>
      <div className={`flex items-end gap-4 ${sizeClasses[size]}`}>
        <DinoSprite frame={frame} />
        <LlamaSprite frame={frame} />
      </div>
      <div className="flex items-center gap-2 text-muted-foreground">
        <span className={`font-medium animate-pulse ${size === 'sm' ? 'text-xs' : 'text-sm'}`}>{message}</span>
        <span className="flex gap-1">
          <span className="w-1.5 h-1.5 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></span>
          <span className="w-1.5 h-1.5 bg-primary rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></span>
          <span className="w-1.5 h-1.5 bg-primary rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></span>
        </span>
      </div>
    </div>
  );
};

export default DinoLlamaLoader;
